import { useNavigate } from "react-router-dom";
import { Zap, ArrowRight } from "lucide-react";

export function Federal2025Banner({ isDark, surface, text, textSec }) {
  const navigate = useNavigate();
  return (
    <section className="px-4 py-8" data-testid="federal2025-banner" style={{ backgroundColor: isDark ? "#080E1A" : "#F1F5F9" }}>
      <div className="max-w-6xl mx-auto">
        <div
          className="overflow-hidden transition-all duration-300"
          style={{
            background: isDark ? "linear-gradient(135deg, #1E293B 0%, #162032 100%)" : "#FFFFFF",
            border: `1px solid ${isDark ? "rgba(225,29,72,0.18)" : "rgba(226,232,240,0.85)"}`,
            borderRadius: 20,
            boxShadow: isDark ? "0 20px 50px -10px rgba(225,29,72,0.08), 0 4px 16px rgba(0,0,0,0.4)" : "0 4px 20px -2px rgba(15,23,42,0.08)",
          }}
        >
          <div style={{ height: 3, background: "linear-gradient(90deg, #E11D48, #F43F5E88)" }} />
          <div className="p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-6">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-3 flex-wrap">
                <span className="text-xs font-semibold px-2.5 py-1 rounded-full" style={{ background: "rgba(225,29,72,0.10)", color: "#E11D48", border: "1px solid rgba(225,29,72,0.20)" }}>FEDERAL 2025</span>
                <span className="text-xs font-semibold px-2.5 py-1 rounded-full" style={{ background: "rgba(16,185,129,0.10)", color: "#10B981", border: "1px solid rgba(16,185,129,0.20)" }}>LABOR MAJORITY</span>
              </div>
              <h2 className="text-xl sm:text-2xl font-bold mb-2 tracking-tight" style={{ color: text, fontFamily: "Outfit, sans-serif" }}>
                Australian Federal Election — May 3, 2025
              </h2>
              <p className="text-sm mb-4" style={{ color: textSec }}>
                Labor won 87 seats. Albanese re-elected PM. Greens lost Melbourne. Teals held all seats.
              </p>
              <div className="flex flex-wrap gap-5">
                {[
                  { party: "ALP", seats: 87, color: "#E11D48" },
                  { party: "Coalition", seats: 48, color: "#2563EB" },
                  { party: "Greens", seats: 4, color: "#10B981" },
                  { party: "Teals", seats: 8, color: "#0D9488" },
                ].map(({ party, seats, color }) => (
                  <div key={party} className="flex items-baseline gap-1.5">
                    <span className="text-2xl font-black" style={{ color, fontFamily: "Outfit, sans-serif" }}>{seats}</span>
                    <span className="text-xs font-medium" style={{ color: textSec }}>{party}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col gap-2 sm:items-end flex-shrink-0">
              {["Albanese vs Dutton head-to-head", "8 key election issues", "Notable seat results", "Teal wave & Greens losses"].map((item) => (
                <div key={item} className="flex items-center gap-1.5 text-xs" style={{ color: textSec }}>
                  <Zap style={{ width: 12, height: 12, color: "#FACC15", flexShrink: 0 }} />
                  {item}
                </div>
              ))}
              <button
                onClick={() => navigate("/federal-2025")}
                className="mt-4 flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold transition-all hover:-translate-y-0.5 active:scale-[0.98]"
                style={{ background: "#E11D48", color: "#fff", boxShadow: "0 6px 18px rgba(225,29,72,0.28)" }}
                data-testid="view-federal2025-btn"
              >
                Federal 2025 Results Guide <ArrowRight style={{ width: 15, height: 15 }} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
